export default {
  ACCOUNT_STORED_PAYMENTS: 'ACCOUNT_STORED_PAYMENTS',
  ALL_SHOPPING_LISTS: 'ALL_SHOPPING_LISTS',
  ALTERNATIVES: 'ALTERNATIVES',
  BEFORE_GO_FORGOTTEN_ITEMS: 'BEFORE_GO_FORGOTTEN_ITEMS',
  BEFORE_GO_MISSED_PROMOS: 'BEFORE_GO_MISSED_PROMOS',
  BEFORE_GO_SPECIAL_OFFERS: 'BEFORE_GO_SPECIAL_OFFERS',
  BOP: 'BOP',
  BUNDLES: 'BUNDLES',
  CALENDAR_EVENTS: 'CALENDAR_EVENTS',
  CHANGE_EMAIL_AND_PASSWORD: 'CHANGE_EMAIL_AND_PASSWORD',
  CHECKOUT_FREE_GIFT: 'CHECKOUT_FREE_GIFT',
  COOKIES: 'COOKIES',
  COMBO_DEALS: 'COMBO_DEALS',
  CONFIRM_OVER18: 'CONFIRM_OVER18',
  CONTACT_DETAILS: 'CONTACT_DETAILS',
  COUPONS: 'COUPONS',
  DELIVERY_ADDRESS_BOOK: 'DELIVERY_ADDRESS_BOOK',
  DELIVERY_ADDRESS_BOOK_ADD_ADDRESS: 'DELIVERY_ADDRESS_BOOK_ADD_ADDRESS',
  DELIVERY_ADDRESS_BOOK_EDIT_ADDRESS: 'DELIVERY_ADDRESS_BOOK_EDIT_ADDRESS',
  DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS: 'DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS',
  DELIVERY_PREFERENCES: 'DELIVERY_PREFERENCES',
  EVENT_LANDING: 'EVENT_LANDING',
  EVENT_PRODUCTS: 'EVENT_PRODUCTS',
  FACEBOOK_SETTINGS: 'FACEBOOK_SETTINGS',
  FAVOURITES: 'FAVOURITES',
  FOOD_PROFILE: 'FOOD_PROFILE',
  HEALTHIFY: 'HEALTHIFY',
  HEALTHIFY_SETTINGS: 'HEALTHIFY_SETTINGS',
  HOMEPAGE: 'HOMEPAGE',
  INGREDIENTSEARCH: 'INGREDIENTSEARCH',
  INVITE_A_FRIEND: 'INVITE_A_FRIEND',
  LOGIN_FINALISE: 'LOGIN_FINALISE',
  LOGIN: 'LOGIN',
  MARKETING_COMMUNICATIONS: 'MARKETING_COMMUNICATIONS',
  SMS_REMINDERS: 'SMS_REMINDERS',
  MOBILE_SPLASH_PAGE: 'MOBILE_SPLASH_PAGE',
  MULTISEARCH: 'MULTISEARCH',
  NA: 'NA',
  OFFER_DETAILS: 'OFFER_DETAILS',
  OFFERS_LANDING: 'OFFERS_LANDING',
  OFFERS_ON_FAVOURITES: 'OFFERS_ON_FAVOURITES',
  OFFERS_PRODUCTS: 'OFFERS_PRODUCTS',
  ONE_PAGE_CHECKOUT: 'ONE_PAGE_CHECKOUT',
  ONE_PAGE_EVENT: 'ONE_PAGE_EVENT',
  OR_LANDING: 'OR_LANDING',
  OR_REGISTRATION: 'OR_REGISTRATION',
  OR_MANAGEMENT_PAGE: 'OR_MANAGEMENT_PAGE',
  ORDER_CONFIRM: 'ORDER_CONFIRM',
  ORDER_REFUND_REQUEST_CONFIRMATION: 'ORDER_REFUND_REQUEST_CONFIRMATION',
  ORDER_SUMMARY_WAIT: 'ORDER_SUMMARY_WAIT',
  ORDER_SUMMARY: 'ORDER_SUMMARY',
  ORDER: 'ORDER',
  PAYMENT_DETAILS: 'PAYMENT_DETAILS',
  PAYMENT_PROCESSING: 'PAYMENT_PROCESSING',
  PAYPAL: 'PAYPAL',
  PAYPAL_LOGIN_SETTINGS: 'PAYPAL_LOGIN_SETTINGS',
  RECIPES: 'RECIPES',
  RECOMMENDED: 'RECOMMENDED',
  REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
  REGISTRATION_MISSING_DETAILS: 'REGISTRATION_MISSING_DETAILS',
  REGISTRATION_NO_DELIVERY: 'REGISTRATION_NO_DELIVERY',
  REGISTRATION_VOUCHER: 'REGISTRATION_VOUCHER',
  REGISTRATION: 'REGISTRATION',
  SAVING_PASS_GROUP_DETAILS: 'SAVING_PASS_GROUP_DETAILS',
  SAVING_PASS: 'SAVING_PASS',
  SEARCH: 'SEARCH',
  SEARCH_NO_RESULTS: 'SEARCH_NO_RESULTS',
  SEASONAL_LANDING: 'SEASONAL_LANDING',
  SEASONAL_PRODUCTS: 'SEASONAL_PRODUCTS',
  SETTINGS: 'SETTINGS',
  SHOP_LANDING: 'SHOP_LANDING',
  SHOP_PRODUCTS: 'SHOP_PRODUCTS',
  SHOPPING_LIST: 'SHOPPING_LIST',
  SLOT_ADVICE_EXPIRED: 'SLOT_ADVICE_EXPIRED',
  SLOT_BOOKING_EDIT_ORDER: 'SLOT_BOOKING_EDIT_ORDER',
  SLOT_BOOKING_NOT_CHECKOUT: 'SLOT_BOOKING_NOT_CHECKOUT',
  SLOT_BOOKING: 'SLOT_BOOKING',
  SLOT_PROBLEM: 'SLOT_PROBLEM',
  SLOT_WAIT_CONFIRM: 'SLOT_WAIT_CONFIRM',
  SMART_BASKET: 'SMART_BASKET',
  STATIC_MICROSITE: 'STATIC_MICROSITE',
  STORED_PAYMENT_DETAILS: 'STORED_PAYMENT_DETAILS',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  SUBSCRIPTIONS_BRANDSHOP: 'SUBSCRIPTIONS_BRANDSHOP',
  SUBSCRIPTIONS_PRODUCTS: 'SUBSCRIPTIONS_PRODUCTS',
  SUGGESTED_ORDER: 'SUGGESTED_ORDER',
  SWITCH_AND_SAVE: 'SWITCH_AND_SAVE',
  UNDER18: 'UNDER18',
  VBV_SETUP: 'VBV_SETUP',
  VBV: 'VBV',
  VOUCHER: 'VOUCHER',
  WINE_CELLAR_LANDING: 'WINE_CELLAR_LANDING',
  WINE_CELLAR_PRODUCTS: 'WINE_CELLAR_PRODUCTS',
};
